﻿/**
 * WELIGHT Guitars - Product Page Price Display
 * デポジットページ: 本体総額・オプション価格・内金・残金・送料（地域1件）を表示
 * 通常商品ページ: 本体価格内訳・オプション価格・送料（地域1件）を表示
 *
 * 設置場所: Shopify テーマ > assets/welight-deposit-price.js
 * 読み込み場所: sections/product-template.liquid
 */

(function() {
  'use strict';

  // ── 定数 ──────────────────────────────────────────────────────────────────

  const CURRENCY_SYMBOLS = {
    JPY: '¥',
    USD: '$',
    EUR: '€',
    GBP: '£',
    AUD: 'A$',
    CHF: 'CHF '
  };

  // デポジット商品ハンドル → シリーズキー
  const PRODUCT_SERIES_MAP = {
    'custom-order-deposit-limited-edition-x': 'limited',
    'custom-order-deposit-et':  'et',
    'custom-order-deposit-sh':  'sh',
    'custom-order-deposit-tw':  'tw',
    'custom-order-deposit-uk':  'uk'
  };

  // オプション値 → JSON キー変換
  const CUTAWAY_KEY_MAP = {
    'Standard': 'standard',
    'Cutaway':  'cutaway'
  };

  const PICKUP_KEY_MAP = {
    'Without Pickup': 'without_pickup',
    'Stage Package':  'stage',
    'Blues Package':  'blues',
    'Pro Package':    'pro'
  };

  const PICKUP_LABELS = {
    without_pickup: 'Without Pickup',
    stage:  'Stage Package',
    blues:  'Blues Package',
    pro:    'Pro Package'
  };

  // 通貨 → 送料地域キー（Shopifyマーケットの通貨設定に基づく）
  // JPY はストア内覧用のため除外し、フォールバックは north_america
  const CURRENCY_TO_REGION = {
    USD: 'north_america',
    AUD: 'north_america',
    EUR: 'europe',
    GBP: 'europe',
    CHF: 'europe',
    JPY: null   // 日本国内は送料対象外のため非表示
  };

  // ── ユーティリティ ─────────────────────────────────────────────────────────

  function getActiveCurrency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active)
      ? window.Shopify.currency.active
      : 'JPY';
  }

  function formatPrice(amount, currency) {
    const symbol = CURRENCY_SYMBOLS[currency] || (currency + ' ');
    const formatted = Math.round(Number(amount)).toLocaleString('en-US');
    return symbol + formatted;
  }

  function getCurrentProductHandle() {
    const match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function isDepositProduct() {
    return getCurrentProductHandle().indexOf('custom-order-deposit-') === 0;
  }

  // メタフィールドから prices map を取得（後方互換）
  function getPriceMap(priceTable) {
    if (!priceTable) return null;
    if (typeof priceTable === 'string') {
      try { priceTable = JSON.parse(priceTable); } catch (e) { return null; }
    }
    if (priceTable.prices && typeof priceTable.prices === 'object') {
      return priceTable.prices;
    }
    return priceTable;
  }

  function isSeriesMatch(priceTable) {
    if (!priceTable || !priceTable.series) return true;
    const handle = getCurrentProductHandle();
    const expected = PRODUCT_SERIES_MAP[handle];
    if (!expected) return true;
    const actual = String(priceTable.series).trim().toLowerCase();
    return actual === expected || actual.indexOf(expected) !== -1;
  }

  // 選択中バリアントのオプション取得
  function getSelectedOptions() {
    const form = document.querySelector('form[action="/cart/add"]');
    if (!form) return null;
    const selects = form.querySelectorAll('.single-option-selector');
    const options = {};
    selects.forEach(function(select) {
      const name  = select.dataset.index;
      const value = select.value;
      if (name === 'option1') {
        if (CUTAWAY_KEY_MAP[value] !== undefined) {
          options.cutaway = CUTAWAY_KEY_MAP[value];
        } else if (PICKUP_KEY_MAP[value] !== undefined) {
          options.cutaway = 'standard';
          options.pickup  = PICKUP_KEY_MAP[value];
        }
      } else if (name === 'option2') {
        if (PICKUP_KEY_MAP[value] !== undefined) {
          options.pickup = PICKUP_KEY_MAP[value];
        }
      }
    });
    return options;
  }

  function parseLocalizedMoney(rawText) {
    if (!rawText) return null;

    // 通貨記号・空白・文字列を除去して数値記号のみ残す
    let raw = String(rawText)
      .replace(/ /g, ' ')
      .replace(/[^0-9.,'-]/g, '')
      .replace(/'/g, '')
      .trim();

    if (!raw) return null;

    const hasComma = raw.indexOf(',') !== -1;
    const hasDot = raw.indexOf('.') !== -1;

    if (hasComma && hasDot) {
      // 最後に現れる区切り記号を小数点として扱う
      const lastComma = raw.lastIndexOf(',');
      const lastDot = raw.lastIndexOf('.');
      if (lastComma > lastDot) {
        raw = raw.replace(/\./g, '').replace(',', '.');
      } else {
        raw = raw.replace(/,/g, '');
      }
    } else if (hasComma) {
      // 末尾が 1-2 桁なら小数、それ以外は桁区切り
      raw = /,\d{1,2}$/.test(raw)
        ? raw.replace(',', '.')
        : raw.replace(/,/g, '');
    } else if (hasDot) {
      // 末尾が 1-2 桁なら小数、それ以外は桁区切り
      raw = /\.\d{1,2}$/.test(raw)
        ? raw
        : raw.replace(/\./g, '');
    }

    const n = Number(raw);
    return Number.isFinite(n) ? n : null;
  }

  // 選択中バリアントの表示価格（Shopify側のデポジット金額）を取得
  function getDepositAmount() {
    const priceEl = document.querySelector('.price__regular .price-item--regular');
    if (!priceEl) return null;

    const n = parseLocalizedMoney(priceEl.textContent);
    return n == null ? null : Math.round(n);
  }

  // ── 送料1行 HTML 生成（現在の通貨に対応する地域のみ）─────────────────────

  function buildShippingLine(shipping, shippingRegions, currency) {
    if (!shipping) return '';

    // 通貨から地域を特定
    const regionKey = CURRENCY_TO_REGION[currency];

    // JPY など送料非表示の通貨はスキップ
    if (regionKey === null) return '';

    // 対応地域が見つからない場合は north_america にフォールバック
    const key = (regionKey && shipping[regionKey]) ? regionKey : 'north_america';
    if (!shipping[key]) return '';

    const prices = shipping[key];
    const amount = prices[currency] != null ? prices[currency] : prices['USD'];
    const label  = (shippingRegions && shippingRegions[key])
      ? shippingRegions[key]
      : key;

    return '<span style="color:#555;">' + label + ':&nbsp;</span>'
      + '<strong>' + formatPrice(amount, currency) + '</strong>';
  }

  // ── 表示コンテナ作成（共通）────────────────────────────────────────────────

  function getOrCreateContainer(id) {
    let el = document.getElementById(id);
    if (!el) {
      el = document.createElement('div');
      el.id = id;
      el.style.cssText = [
        'margin-top:16px',
        'padding:16px',
        'border:1px solid #e0e0e0',
        'border-radius:4px',
        'background:#f9f9f9',
        'font-size:14px',
        'line-height:1.8'
      ].join(';');
      const priceContainer = document.querySelector('.product__price, .price');
      if (priceContainer && priceContainer.parentNode) {
        priceContainer.parentNode.insertBefore(el, priceContainer.nextSibling);
      }
    }
    return el;
  }

  // ── デポジットページ用表示 ─────────────────────────────────────────────────

  function updateDepositDisplay() {
    const priceTable = window.welightPriceTable;
    if (!priceTable) return;
    if (!isSeriesMatch(priceTable)) return;

    const priceMap = getPriceMap(priceTable);
    if (!priceMap) return;

    const currency   = getActiveCurrency();
    const options    = getSelectedOptions();
    if (!options) return;

    const cutawayKey = options.cutaway || 'standard';
    const pickupKey  = options.pickup  || 'without_pickup';
    const variantKey = cutawayKey + '__' + pickupKey;

    // 合計価格（prices セクション）
    const variantPrices = priceMap[variantKey];
    if (!variantPrices) return;
    const totalAmount = Math.round(Number(
      variantPrices[currency] != null ? variantPrices[currency] : variantPrices.JPY
    ));

    // デポジット金額（Shopify バリアント価格から取得）
    const depositAmount = getDepositAmount();
    if (!totalAmount || !depositAmount) return;
    const remaining = totalAmount - depositAmount;

    // オプション価格（option_prices セクション）
    const optionPrices = priceTable.option_prices;
    const optionEntry  = optionPrices ? optionPrices[pickupKey] : null;
    const optionAmount = (optionEntry && optionEntry[currency] != null)
      ? optionEntry[currency]
      : (optionEntry ? (optionEntry.JPY || 0) : 0);
    const pickupLabel  = PICKUP_LABELS[pickupKey] || pickupKey;

    // オプション行（Without Pickup または 0 の場合は非表示）
    const optionRow = (pickupKey !== 'without_pickup' && optionAmount > 0)
      ? '<div style="color:#888;font-size:13px;padding-left:12px;margin-top:2px;">'
          + '+ ' + pickupLabel + ': ' + formatPrice(optionAmount, currency)
        + '</div>'
      : '';

    // 送料（地域1件のみ）
    const shippingLine = buildShippingLine(
      priceTable.shipping, priceTable.shipping_regions, currency
    );
    const shippingSection = shippingLine
      ? '<div style="margin-top:12px;border-top:1px solid #e0e0e0;padding-top:10px;font-size:13px;">'
          + '<span style="font-weight:bold;color:#333;">Shipping (charged at final payment): </span>'
          + shippingLine
        + '</div>'
      : '';

    const html = [
      '<div style="font-weight:bold;font-size:15px;margin-bottom:6px;">',
        'Total Price (excl. shipping): <span style="color:#222;">', formatPrice(totalAmount, currency), '</span>',
      '</div>',
      optionRow,
      '<div style="color:#555;padding-left:12px;margin-top:4px;">',
        '└ Deposit (today): <strong>', formatPrice(depositAmount, currency), '</strong>',
      '</div>',
      '<div style="color:#555;padding-left:12px;">',
        '└ Remaining Balance (before shipping): <strong>', formatPrice(remaining, currency), '</strong>',
      '</div>',
      shippingSection
    ].join('');

    getOrCreateContainer('welight-price-display').innerHTML = html;
  }

  // ── 通常商品詳細ページ用表示 ──────────────────────────────────────────────

  function updateProductDisplay() {
    const priceTable = window.welightPriceTable;
    if (!priceTable) return;
    if (typeof priceTable !== 'object') return;

    const currency   = getActiveCurrency();
    const options    = getSelectedOptions();
    if (!options) return;

    const cutawayKey   = options.cutaway || 'standard';
    const pickupKey    = options.pickup  || 'without_pickup';
    const basePrices   = priceTable.base_prices;
    const optionPrices = priceTable.option_prices;

    if (!basePrices) return;

    const baseEntry   = basePrices[cutawayKey];
    const optionEntry = optionPrices ? optionPrices[pickupKey] : null;
    if (!baseEntry) return;

    const baseAmount   = baseEntry[currency] != null ? baseEntry[currency] : baseEntry['JPY'];
    const optionAmount = (optionEntry && optionEntry[currency] != null)
      ? optionEntry[currency]
      : (optionEntry ? (optionEntry.JPY || 0) : 0);

    const cutawayLabel = cutawayKey === 'cutaway' ? ' + Cutaway' : '';
    const pickupLabel  = PICKUP_LABELS[pickupKey] || pickupKey;

    const optionRow = (pickupKey !== 'without_pickup' && optionAmount > 0)
      ? '<div style="color:#555;padding-left:12px;margin-top:2px;">'
          + '+ ' + pickupLabel + ': <strong>' + formatPrice(optionAmount, currency) + '</strong>'
        + '</div>'
      : '';

    const shippingLine = buildShippingLine(
      priceTable.shipping, priceTable.shipping_regions, currency
    );
    const shippingSection = shippingLine
      ? '<div style="margin-top:10px;font-size:13px;border-top:1px solid #e0e0e0;padding-top:8px;">'
          + '<span style="font-weight:bold;color:#333;">Shipping: </span>'
          + shippingLine
        + '</div>'
      : '';

    const html = [
      '<div style="font-weight:bold;font-size:14px;margin-bottom:6px;color:#333;">Price Breakdown</div>',
      '<div style="color:#555;">Body', cutawayLabel, ': <strong>', formatPrice(baseAmount, currency), '</strong></div>',
      optionRow,
      shippingSection
    ].join('');

    getOrCreateContainer('welight-price-display').innerHTML = html;
  }

  // ── 振り分け・イベント登録 ────────────────────────────────────────────────

  function updateDisplay() {
    if (isDepositProduct()) {
      updateDepositDisplay();
    } else {
      updateProductDisplay();
    }
  }

  function init() {
    updateDisplay();

    document.addEventListener('variant:changed', function() {
      setTimeout(updateDisplay, 100);
    });

    const form = document.querySelector('form[action="/cart/add"]');
    if (form) {
      form.addEventListener('change', function() {
        setTimeout(updateDisplay, 100);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
